import Header from "./components/header";
import Footer from "./components/footer";
import Loader from "./components/loader";
import { useEffect, useState } from "react";
import { useCMSContent } from "../hooks/useCMSContent";

const AboutUs = () => {
  const [loading, setLoading] = useState(true);
  
  // CMS Content Hook - fetches content from API, falls back to hardcoded if unavailable
  const { cmsContent, getSectionContent, getSectionItems, hasCMSContent } = useCMSContent('about-us');
  
  useEffect(() => {
    // SEO Meta Tags (will be overridden by CMS if available)
    if (!hasCMSContent) {
      document.title = "About TAK8 | Perth Car Hire Experts";
      
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', 'TAK8 is your trusted local partner for car rental in Perth. Count on our friendly team, quality vehicles, and a hassle-free booking experience every time.');
      }
      
      // Set or create Open Graph tags
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute('content', 'Get to Know TAK8 – Perth Car Rental');
      
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.setAttribute('content', 'Discover how TAK8 is changing car rental in Perth with flexible, fair, and customer-first service.');
      
      let ogType = document.querySelector('meta[property="og:type"]');
      if (!ogType) {
        ogType = document.createElement('meta');
        ogType.setAttribute('property', 'og:type');
        document.head.appendChild(ogType);
      }
      ogType.setAttribute('content', 'website');
    }
    
    setTimeout(() => setLoading(false), 2000);
  }, [hasCMSContent]);
  //const handleLoad = () => {setLoading(false)}
  return (
    <>
     {loading ? <Loader /> : ""}
      <Header  />
      <section className={`MainSection`}>
        <div class="container">
          <h1 class="Head_2 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('hero', 'title', 'About Us') }} />
        </div>
      </section>
      <section >
        <div class="container">
          <div class="AboutInfo">
            <div class="imageBorder"><img src="img/about_banner_u.png" alt="About" loading="lazy" /></div>

            <div class="Content">
              <h2 class="Head_2 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('about-info', 'title', 'About TAK8 Car Rental') }} />
              <div 
                className="Pra_1 rich-content"
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent('about-info', 'description', 'Welcome to TAK8 Car Rental, your premier choice for car rentals in East Perth, Western Australia, and beyond. Founded with a commitment to providing unparalleled rental experiences, TAK8 is dedicated to serving the local community and travelers alike with top-notch service, reliability, and convenience.') 
                }}
              />
            </div>
          </div>
          <div class="row RowVision">
            <div class="col-md-6">
              <img src="img/icon/vision.svg" alt="Vision" />
              <h3 class="Head_3 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('vision', 'title', 'Our Vision') }} />
              <div 
                className="Pra_1 rich-content"
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent('vision', 'description', 'At TAK8 Car Rental, our vision is clear: to become the go-to destination for car rentals in East Perth and throughout Western Australia. We aim to set new standards of excellence in the industry by offering a wide selection of vehicles, transparent pricing, and exceptional customer service.') 
                }}
              />
            </div>
            <div class="col-md-6">
              <img src="img/icon/mission.svg" alt="Mission" />
              <h3 class="Head_3 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('mission', 'title', 'Our Mission') }} />
              <div 
                className="Pra_1 rich-content"
                dangerouslySetInnerHTML={{ 
                  __html: getSectionContent('mission', 'description', 'TAK8 Car Rental is on a mission to make car rental simple, affordable, and enjoyable. Whether you\'re exploring the sights of Perth, embarking on a road trip across Western Australia, or in need of temporary transportation, we\'re here to meet your needs with professionalism and expertise.') 
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <section >
        <div class="container">
          <div class="CustomHeading">
            <h2 class="Head_1 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('why-choose', 'subtitle', 'Why Choose US') }} />
            <h3 class="Head_2 rich-content" dangerouslySetInnerHTML={{ __html: getSectionContent('why-choose', 'title', 'Why Choose TAK8 Car Rental?') }} />
            <div 
              className="Pra_1 rich-content"
              dangerouslySetInnerHTML={{ 
                __html: getSectionContent('why-choose', 'description', 'We present many guarantees and advantages when you rent a car with us for your trip. Here are some of the advantages that you will get') 
              }}
            />
          </div>
          <div class="row align-items-center RowChoose">
            <div class="col-md-4 ">
              <div class="imageBorder PaddingBottom">
                <img src="img/whychoose.png" alt="Choose" />
              </div>

            </div>
            <div class="col-md-8">
              <ul>
                {(() => {
                  const whyChooseItems = getSectionItems('why-choose');
                  if (whyChooseItems && whyChooseItems.length > 0) {
                    return whyChooseItems.map((item, index) => (
                      <li key={item.id || index}>
                        <span class="Icon ">
                          <img src={item.icon ? `img/icon/${item.icon}.svg` : `img/icon/local.svg`} alt={typeof item.title === 'string' ? item.title.replace(/<[^>]*>/g, '') : 'Item'} />
                        </span>
                        <span class="Text">
                          <span class="Head_4 rich-content" dangerouslySetInnerHTML={{ __html: item.title }} />
                          <span 
                            className="Pra_1 rich-content"
                            dangerouslySetInnerHTML={{ __html: item.description }}
                          />
                        </span>
                      </li>
                    ));
                  }
                  // Fallback to hardcoded items
                  return (
                    <>
                      <li>
                        <span class="Icon ">
                          <img src="img/icon/local.svg" alt="Local" />
                        </span>
                        <span class="Text">
                          <span class="Head_4">Local Expertise</span>
                          <span class="Pra_1">
                            As a locally owned and operated business, we understand
                            the unique needs of our customers. Count on us for
                            personalized service, insider tips, and recommendations to
                            make the most of your journey.
                          </span>
                        </span>
                      </li>
                      <li>
                        <span class="Icon">
                          <img src="img/icon/quality.svg" alt="Quality" />
                        </span>
                        <span class="Text">
                          <span class="Head_4">Quality Fleet</span>
                          <span class="Pra_1">
                            We take pride in our well-maintained fleet of vehicles,
                            ranging from compact cars to spacious SUVs and 7-seaters.
                            Each vehicle is meticulously inspected and cleaned to
                            ensure your safety and comfort on the road.
                          </span>
                        </span>
                      </li>
                      <li>
                        <span class="Icon">
                          <img src="img/icon/convenience.svg" alt="Convenience" />
                        </span>
                        <span class="Text">
                          <span class="Head_4">Convenience</span>
                          <span class="Pra_1">
                            Located in the heart of WA East Perth, our rental office
                            is easily accessible and conveniently situated for your
                            convenience. Plus, enjoy flexible booking options,
                            extended hours, and hassle-free returns to accommodate
                            your busy schedule.
                          </span>
                        </span>
                      </li>
                    </>
                  );
                })()}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutUs;
